import React from 'react';
import {Avatar, Tooltip} from '@mui/material';
import EditCloneDeleteMenu from "../../Menus/EditCloneDeleteMenu";



export const StakeholderListGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },

    {    field: 'id',
        headerName: 'ID',
        sortable: true,
        width: 90,
    },

    {    field: 'fileId',
        headerName: 'File ID',
        sortable: true,
        width: 180,
    },
    {
        field: 'recordId',
        headerName: 'Record ID',
        sortable: true,
        width: 60,
    },
    {
        field: 'paticipations',
        headerName: '',
        description: '',
        sortable: false,
        width: 25,
        renderCell: (stakeholderLists) => {
            if (stakeholderLists.row.participations > 0) {
                return (
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Participation contracts exist on this title"}>
                        <Avatar
                            sx={{height: 20, width: 20, fontSize: 16, bgcolor: "rgb(30,144,255)"}}>Pa</Avatar>
                    </Tooltip>)
            }
            else {return(<p></p>)}
        }

    },
    {
        field: 'residuals',
        headerName: '',
        description: '',
        sortable: false,
        width: 25,
        renderCell: (stakeholderLists) => {
            if (stakeholderLists.row.residuals > 0) {
                return (
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Residuals contracts exist on this title"}>
                        <Avatar
                            sx={{height: 23, width: 23, fontSize: 14, bgcolor: "rgb(30,144,255)"}}>Re</Avatar>
                    </Tooltip>)
            }
            else {return(<p></p>)}
        }
    },
    {
        field: 'royalties',
        headerName: '',
        description: '',
        sortable: false,
        width: 25,
        renderCell: (stakeholderLists) => {
            if (stakeholderLists.row.royalties > 0) {
                return (
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Royalties contracts exist on this title"}>
                        <Avatar
                            sx={{height: 20, width: 20, fontSize: 16, bgcolor: "rgb(30,144,255)"}}>Ro</Avatar>
                    </Tooltip>)
            }
            else {return(<p></p>)}
        }
    },
    {
        field: 'productId',
        headerName: 'Product ID',
        sortable: true,
        width: 100,
    },
    {
        field: 'productName',
        headerName: 'Product Name',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 300,
    },
    {
        field: 'episodeName',
        headerName: 'Episode Name',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 250,
    },
    {
        field: 'seriesExternalId',
        headerName: 'Series ID',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 80,

    },
    {
        field: 'seriesName',
        headerName: 'Series Name',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 250,

    },

    {
        field: 'seasonExternalId',
        headerName: 'Season ID',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 80,
    },
    {
        field: 'season',
        headerName: '#',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 40,
    },
    {
        field: 'seasonName',
        headerName: 'Season Name',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 250,
    },

    {
        field: 'guild',
        headerName: 'Guild',
        sortable: true,
        width: 60,
    },
    {
        field: 'fsoId',
        headerName: 'FSO ID',
        sortable: true,
        width: 60,
    },
    {
        field: 'fsoTaxId',
        headerName: 'FSO Tax Id',
        sortable: true,
        width: 80,
    },
    {
        field: 'fsoFirstName',
        headerName: 'FSO First Name',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'fsoLastName',
        headerName: 'FSO Last Name',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'fsoSuffix',
        headerName: 'FSO Suffix',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'contractedPartyId',
        headerName: 'Contracted Party ID',
        sortable: true,
        width: 150,
    },
    {
        field: 'contractedPartyTaxId',
        headerName: 'Contracted Party Tax Id',
        sortable: true,
        width: 150,
    },
    {
        field: 'contractedPartyFirstName',
        headerName: 'Contracted Party First Name',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'contractedPartyLastName',
        headerName: 'Contracted Party Last Name',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'contractedPartySuffix',
        headerName: 'Contracted Party Suffix',
        sortable: true,
        // editable: true,
        width: 150,
    },
    {
        field: 'contractedPartyCompanyName',
        headerName: 'Contracted Party Company',
        sortable: true,
        // editable: true,
        width: 150,
    },
    {
        field: 'payeeId',
        headerName: 'Payee ID',
        sortable: true,
        width: 150,
    },
    {
        field: 'payeeTaxId',
        headerName: 'Payee Tax Id',
        sortable: true,
        width: 150,
    },
    {
        field: 'payeeFirstName',
        headerName: 'Payee First Name',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'payeeLastName',
        headerName: 'Payee Last Name',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'payeeSuffix',
        headerName: 'Payee Suffix',
        sortable: true,
        // editable: true,
        width: 150,
    },
    {
        field: 'payeeCompanyName',
        headerName: 'Payee Company',
        sortable: true,
        // editable: true,
        width: 150,
    },
    {
        field: 'jobCode',
        headerName: 'Job Code',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'contractLength',
        headerName: 'Contract Length',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'contractDate',
        headerName: 'Contract Date',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'compensation',
        headerName: 'Compensation',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'pensionedCompensation',
        headerName: 'Pensioned Compensation',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'scaleCompensation',
        headerName: 'Scale Compensation',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'overtimeCompensation',
        headerName: 'Overtime Compensation',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'premiumOvertimeCompensation',
        headerName: 'Premium Overtime Compensation',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'wardrobeCompensation',
        headerName: 'Wardrobe Compensation',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'allowances',
        headerName: 'Allowances',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'penalties',
        headerName: 'Penalties',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'additFringedCompensation',
        headerName: 'Addit Fringed',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'advance',
        headerName: 'Advance',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'advance2',
        headerName: 'Advance 2',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'workBeginDate',
        headerName: 'Work Begin Date',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'daysWorked',
        headerName: 'Days Worked',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'guaranteedDays',
        headerName: 'Guar. Days',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'taxingLocation',
        headerName: 'Taxing Location',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'participant',
        headerName: 'Participant',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'guildEquivalent',
        headerName: 'Guild Equivalent',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'note1',
        headerName: 'Note 1',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'note2',
        headerName: 'Note 2',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'note3',
        headerName: 'Note 3',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'status',
        headerName: 'status',
        description: '',
        width: 100,
        hide: false
    },
    {
        field: 'createdOn',
        headerName: 'createdOn',
        description: '',
        width: 100,
        hide: true
    },
    {
        field: 'createdBy',
        headerName: 'createdBy',
        description: '',
        width: 100,
        hide: true
    },
    {
        field: 'lastModifiedOn',
        headerName: 'lastModifiedOn',
        description: '',
        width: 100,
        hide: true
    },
    {
        field: 'lastModifiedBy',
        headerName: 'lastModifiedBy',
        description: '',
        width: 100,
        hide: true
    },
];
